// 価格スライダー
let priceRangeSlider = undefined;

class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 500);

    //this.querySelector('form').addEventListener('input', this.debouncedOnSubmit.bind(this));

    const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
    if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);

    if (document.querySelector('#SortBy')) {
      document.querySelector('#SortBy').addEventListener('change', (event) => this.onChangeSortHandler(event));
    }
    if (document.querySelector('#Limit-top')) {
      document.querySelector('#Limit-top').addEventListener('change', (event) => FacetFiltersForm.onChangeLimitHandler(event));
    }
    if (document.querySelector('#Limit-bottom')) {
      document.querySelector('#Limit-bottom').addEventListener('change', (event) => FacetFiltersForm.onChangeLimitHandler(event));
    }
    document.querySelector('#filter-submit').addEventListener('click', this.debouncedOnSubmit.bind(this));
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    }
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const countContainer = document.getElementById('ProductCount');
    const countContainerDesktop = document.getElementById('ProductCountDesktop');
    document.getElementById('ProductGridContainer').querySelector('.collection').classList.add('loading');
    if (countContainer) {
      countContainer.classList.add('loading');
    }
    if (countContainerDesktop) {
      countContainerDesktop.classList.add('loading');
    }

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = element => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl) ?
        FacetFiltersForm.renderSectionFromCache(filterDataUrl, event) :
        FacetFiltersForm.renderSectionFromFetch(url, event);
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then(response => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        //FacetFiltersForm.renderProductCount(html);
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    //FacetFiltersForm.renderProductCount(html);
  }

  static renderProductGridContainer(html) {
    document.getElementById('ProductGridContainer').innerHTML = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductGridContainer').innerHTML;
    
    if (document.querySelector('#Limit-top')) {
      document.querySelector('#Limit-top').addEventListener('change', (event) => FacetFiltersForm.onChangeLimitHandler(event));
    }
    if (document.querySelector('#Limit-bottom')) {
      document.querySelector('#Limit-bottom').addEventListener('change', (event) => FacetFiltersForm.onChangeLimitHandler(event));
    }

    // 獲得可能ポイント数を表示
    updateLoyaltyTargets();

    // 商品画像スライダーのセット
    FacetFiltersForm.setImgSlider();
  }

  // HACK: クラスに切り分けたい
  static setImgSlider() {
    //不要なスクリプトタグを削除
    const prdListEls = document.getElementById('ProductGridContainer').querySelectorAll('.prd-list');
    const ids = Array.from(prdListEls).map(prdListElement => {
      const scriptElements = prdListElement.getElementsByTagName('script');
      Array.from(scriptElements).forEach(element => element.remove());
      return prdListElement.getAttribute('id');
    });

    // slideをセット
    ids.forEach(id => {
      const main = new Splide(".fku-m" + id, {
        type: "loop",
        drag: true,
        rewind: true,
        pagination: false,
        arrows: false,
        destroy: true
      });

      const thumbnails = new Splide(".fku-t" + id, {
        arrows: "slider",
        drag: "free",
        perPage: 4,
        flickPower: 300,
        fixedWidth: 60,
        fixedHeight: 70,
        gap: 10,
        rewind: false,
        pagination: false,
        cover: true,
        isNavigation: true,
        destroy: true
      });

      const size = new Splide(".fku-s" + id, {
        type: "loop",
        drag: false,
        rewind: false,
        pagination: false,
        arrows: false,
        destroy: true
      });

      main.sync(thumbnails);
      main.sync(size);
      main.mount();
      size.mount();
      thumbnails.mount();
    });

    // ちらつき防止
    const doc_fku_variation = document.getElementsByName('fku-splide-thumb');
    Array.from(doc_fku_variation).forEach(node => node.style.display = '');
  }

  static renderProductCount(html) {
    const count = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductCount').innerHTML
    const container = document.getElementById('ProductCount');
    const containerDesktop = document.getElementById('ProductCountDesktop');
    container.innerHTML = count;
    container.classList.remove('loading');
    if (containerDesktop) {
      containerDesktop.innerHTML = count;
      containerDesktop.classList.remove('loading');
    }
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');

    const facetDetailsElements =
      parsedHTML.querySelectorAll('#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter');
    const matchesIndex = (element) => {
      const jsFilter = event ? event.target.closest('.js-filter') : undefined;
      return jsFilter ? element.dataset.index === jsFilter.dataset.index : false;
    }
    const facetsToRender = Array.from(facetDetailsElements).filter(element => !matchesIndex(element));
    const countsToRender = Array.from(facetDetailsElements).find(matchesIndex);

    facetsToRender.forEach((element) => {
      document.querySelector(`.js-filter[data-index="${element.dataset.index}"]`).innerHTML = element.innerHTML;
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);

    if (countsToRender) FacetFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
    })

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = ['.mobile-facets__open', '.mobile-facets__count', '.sorting'];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML;
    });

    //document.getElementById('FacetFiltersFormMobile').closest('menu-drawer').bindEvents();
  }

  static renderCounts(source, target) {
    const targetElement = target.querySelector('.facets__selected');
    const sourceElement = source.querySelector('.facets__selected');

    if (sourceElement && targetElement) {
      target.querySelector('.facets__selected').outerHTML = source.querySelector('.facets__selected').outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
    return [
      {
        section: document.getElementById('product-grid').dataset.id,
      }
    ]
  }

  onChangeSortHandler(event) {
    const url = new URL(document.location.href);
    url.searchParams.set('sort_by', event.target.value);
    url.searchParams.set('page', 1);
    location.href = url.href;
  }


  // renderProductGridContainer()内で呼び出すためにstaticにしている
  static onChangeLimitHandler(event) {
    const url = new URL(document.location.href);
    url.searchParams.set('limit', event.target.value);
    url.searchParams.set('page', 1);
    location.href = url.href;
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const formData = new FormData(event.target.closest('form'));

    const searchAll = formData.getAll('filter.p.m.my_fields.category_all');
    formData.delete('filter.p.m.my_fields.category_all');

    // ++++++++++++++++++++++++++++++++++
    // 1階層目の絞り込み
    for (let values of formData.getAll('floor1')) {
      for (const data of searchAll) {
        const result = data.split(',',)
        if (result[0] === values) {
          formData.append('filter.p.m.my_fields.category_all', data)
        }
      }
    }

    // ++++++++++++++++++++++++++++++++++
    // 2階層目の絞り込み
    for (let values of formData.getAll('floor2')) {
      for (const data of searchAll) {
        const result = data.split(',',)
        if (result[1] === values) {
          formData.append('filter.p.m.my_fields.category_all', data)
        }
      }
    }

    // ++++++++++++++++++++++++++++++++++
    // 3階層目の絞り込み
    for (let values of formData.getAll('floor3')) {
      for (const data of searchAll) {
        const result = data.split(',',)
        if (result[2] === values) {
          formData.append('filter.p.m.my_fields.category_all', data)
        }
      }
    }

    // ++++++++++++++++++++++++++++++++++
    // 価格スライダー
    const priceRange = priceRangeSlider.noUiSlider.get();
    formData.set('filter.v.price.gte', priceRange[0]);
    formData.set('filter.v.price.lte', priceRange[1]);

    // ++++++++++++++++++++++++++++++++++
    // 並び替え
    if (document.querySelector('#SortBy')) {
      formData.set('sort_by', document.querySelector('#SortBy').value);
    }

    // ++++++++++++++++++++++++++++++++++
    // 表示件数
    if (document.querySelector('#Limit-top')) {
      formData.set('limit', document.querySelector('#Limit-top').value);
    }

    const searchParams = new URLSearchParams(formData).toString();
    FacetFiltersForm.renderPage(searchParams, event);

    // 絞り込みメニュー閉じる
    document.querySelector('body').classList.remove('filters_open');
    document.querySelector('.nav_overlay').style.display = 'none';
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url = event.currentTarget.href.indexOf('?') == -1 ? '' : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    FacetFiltersForm.renderPage(url);
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();

class PriceRange extends HTMLElement {
  constructor() {
    super();
    /*
    this.querySelectorAll('input')
      .forEach(element => element.addEventListener('change', this.onRangeChange.bind(this)));

    this.setMinAndMaxValues();
     */

    // ++++++++++++++++++++++++++++++++++
    // スライダー設定
    const param = (new URL(document.location)).searchParams;
    let startMin = Number.parseInt(param.get('filter.v.price.gte'));
    if (Number.isNaN(startMin)) {
      startMin = 0;
    }
    let startMax = Number.parseInt(param.get('filter.v.price.lte'));
    if (Number.isNaN(startMax)) {
      startMax = this.maxPriceAmount;
    }

    priceRangeSlider = document.getElementById('slider');
    noUiSlider.create(priceRangeSlider, {
      start: [startMin, startMax],
      step: 100,
      connect: true,
      range: {
        'min': 0,
        'max': this.maxPriceAmount,
      },
      tooltips: [wNumb({ decimals: 0 }), wNumb({ decimals: 0 })],
      pips: {
        mode: 'positions',
        values: [0, 33.3333, 66.6667, 100],
        density: 100
      },
    });
  }

  get maxPriceAmount() {
    const v = this.getAttribute('data-max-price-amount');
    const n = Number.parseInt(v);
    return Number.isNaN(n) ? 0 : n;
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll('input');
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput.value) minInput.setAttribute('max', maxInput.value);
    if (minInput.value) maxInput.setAttribute('min', minInput.value);
    if (minInput.value === '') maxInput.setAttribute('min', 0);
    if (maxInput.value === '') minInput.setAttribute('max', maxInput.getAttribute('max'));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute('min'));
    const max = Number(input.getAttribute('max'));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }
}

customElements.define('price-range', PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    this.querySelector('a').addEventListener('click', (event) => {
      event.preventDefault();
      const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
      form.onActiveFilterClick(event);
    });
  }
}

customElements.define('facet-remove', FacetRemove);

class CategoryCheckbox extends HTMLElement {
  constructor() {
    super();
    this.checkIfSelected()
  }

  checkIfSelected() {
    const params = (new URL(document.location)).searchParams;
    const checkbox = this.querySelector('input');
    const selectedFloorValues = params.getAll(checkbox.name);
    checkbox.checked = selectedFloorValues.some(v => v === checkbox.value);
  }
}

customElements.define('category-checkbox', CategoryCheckbox);
